import { Navigate, BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import "leaflet/dist/leaflet.css";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import AuthPage from "@/pages/AuthPage";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import Analysis from "@/pages/Analysis";
import Projects from "@/pages/Projects";
import Zonification from "@/pages/Zonification";
import Help from "@/pages/Help";
import AdminUsers from "@/pages/AdminUsers";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <p className="label-micro text-white/40 animate-pulse">CARGANDO…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/analisis" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <p className="label-micro text-white/40 animate-pulse">CARGANDO…</p>
      </div>
    );
  }
  if (user) return <Navigate to="/analisis" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/analisis" replace />} />
          <Route path="/login" element={<PublicOnly><AuthPage /></PublicOnly>} />
          {/* Public registration is disabled */}
          <Route path="/registro" element={<Navigate to="/login" replace />} />
          <Route
            element={
              <Protected>
                <AppShell />
              </Protected>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/analisis" element={<Analysis />} />
            <Route path="/proyectos" element={<Projects />} />
            <Route path="/zonificacion" element={<Zonification />} />
            <Route path="/ayuda" element={<Help />} />
            <Route path="/admin/usuarios" element={<AdminOnly><AdminUsers /></AdminOnly>} />
          </Route>
          <Route path="*" element={<Navigate to="/analisis" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </AuthProvider>
  );
}

export default App;
